module.exports = __webpack_public_path__ + "img/selected6-min.57b43a3f.png";